import React, { useState } from 'react';
import { TextField, Button, Typography, Modal, Box, IconButton,  FormControl } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { loginUser } from '../controller.tsx'
import { useUser } from '../Context/UserContext';

const SignInModal = ({ isOpen, setIsOpen }) => {
    const { setUserID } = useUser();

    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');

    const handleClose = () => setIsOpen(false);
    const login = async () => {
        setUserID(await loginUser(userName,password));
        handleClose();
    }
    return(
        <Modal open={isOpen} onClose={handleClose} sx={{overflow:'scroll',}}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
                maxWidth: '90%', '@media (max-width: 600px)': {
                  width: '90%',
                  padding: 2,
                }
            }}>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={handleClose}><CloseIcon /></IconButton>

                 <Typography id="resume" padding="5px 0px" variant="h4">Sign In</Typography>
                 <FormControl fullWidth>
                    <TextField variant="filled" fullWidth required id="uName" label="Username" margin="dense"
                        value={userName}
                        onChange={(event)=>setUserName(event.target.value)}
                    />
                    <TextField variant="filled" fullWidth required id="password" label="Password" margin="dense"
                        value={password}
                        onChange={(event)=>setPassword(event.target.value)}
                        type="password"
                        autoComplete="off"
                    />
                    <Button variant="contained" sx={{ mb: 1, backgroundColor:'#263238' }} onClick={login}>Submit</Button>
                 </FormControl>
            </Box>
        </Modal>
    )
}

export default SignInModal;